module.exports = "https://trybtryb-legacy.web.app/img/video.7e98bbe4.svg";